module.exports = __webpack_public_path__ + "assets/img/data.bd5ec210.svg";